import { Tooltip } from '@/components/ui/Tooltip';
import { XIcon } from '@/icons';
import { CheckSmallCircleFillIcon } from '@/icons/components/CheckSmallCircleFill';
import { InformationmarkSmallCircleIcon } from '@/icons/components/InformationmarkSmallCircle';
import { type PlanType } from '@/types';
import { type Feature, type FeatureData } from './types';
interface Props {
  feature: Feature;
}
export const TableRow = ({
  feature
}: Props) => {
  return <div className="grid min-h-[64px] grid-cols-3 gap-x-lg border-b border-alternative laptop-sm:grid-cols-4" data-sentry-component="TableRow" data-sentry-source-file="TableRow.tsx">
      <div className="col-span-3 flex min-w-[160px] items-center gap-xs p-md pb-xs laptop-sm:col-span-1 laptop-sm:pb-md">
        <span className="text-body-lg-medium">{feature.label}</span>
        <Tooltip side="top" className="max-w-[240px] bg-white text-default" arrow={{
        fill: 'white'
      }} trigger={<span>
              <InformationmarkSmallCircleIcon size="sm" className="cursor-pointer [&>*]:fill-assistive" />
            </span>} content={feature.tooltipText} data-sentry-element="Tooltip" data-sentry-source-file="TableRow.tsx" />
      </div>
      <SupportDataCell planType="FREE" data={feature.data.FREE} data-sentry-element="SupportDataCell" data-sentry-source-file="TableRow.tsx" />
      <SupportDataCell planType="BASIC" data={feature.data.BASIC} data-sentry-element="SupportDataCell" data-sentry-source-file="TableRow.tsx" />
      <SupportDataCell planType="PRO" data={feature.data.PRO} data-sentry-element="SupportDataCell" data-sentry-source-file="TableRow.tsx" />
    </div>;
};
interface SupportDataCellProps {
  planType: PlanType;
  data: FeatureData;
}
const SupportDataCell = ({
  planType,
  data
}: SupportDataCellProps) => {
  if (!data.isSupported) {
    return <div className="flex h-full min-w-[160px] items-center gap-xs p-xs laptop-sm:py-md">
        <XIcon size="md" className="[&>*]:fill-disabled" />
      </div>;
  }
  return <div className="flex h-full min-w-[160px] items-center gap-xs p-xs pb-md laptop-sm:py-md" data-sentry-component="SupportDataCell" data-sentry-source-file="TableRow.tsx">
      <CheckSmallCircleFillIcon size="md" className={(() => {
      switch (planType) {
        case 'FREE':
          return '[&>*]:fill-assistive';
        case 'BASIC':
          return '[&>*]:fill-semi-strong';
        case 'PRO':
          return '[&>*]:fill-strong';
      }
    })()} data-sentry-element="CheckSmallCircleFillIcon" data-sentry-source-file="TableRow.tsx" />
      {data.text && <span className="text-body-lg-medium text-neutral">{data.text}</span>}
    </div>;
};